import { registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  withJsonpSupport,
} from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { ApplicationConfig, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  PreloadAllModules,
  provideRouter,
  withPreloading,
} from '@angular/router';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { providePrimeNG } from 'primeng/config';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DEFAULT_PRESET } from './core/theming/presets';
import { BreadcrumbService } from './layout/service/breadcrumb.service';
import { LoadingService } from './layout/service/loading.service';
import { BlobErrorHttpInterceptor } from './interception/blobErrorHttp.interceptor';
import { ErrorHandlerInterceptor } from './interception/error-handler.interceptor';
import { TimeoutInterceptor } from './interception/timeout.interceptor';
import { LoadingInterceptor } from './interception/loading.interceptor';
import { JwtInterceptor } from './seguranca/Jwt-interceptor';
import { ThemeService } from './core/service/theme.service';
import { routes } from './app.routes';

registerLocaleData(localePt, 'pt-BR');

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    providePrimeNG({
      theme: {
        preset: DEFAULT_PRESET,
        options: {
          darkModeSelector: '.dark',
          cssLayer: {
            name: 'primeng',
            // Ordem: reset (CSS reset no projeto) < primeng (Aura preset) <
            // app (overrides pontuais do projeto em styles.scss).
            order: 'reset, primeng, app',
          },
        },
      },
      ripple: true,
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    // Core services
    Title,
    ConfirmationService,
    MessageService,
    BreadcrumbService,
    ThemeService,
    TranslateService,
    LoadingService,
    // HTTP Interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BlobErrorHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    // Depois do tratador de erro de propósito: assim a espera esgotada sobe
    // por ele e o usuário recebe a mesma mensagem de qualquer outra falha.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    // Locale
    { provide: LOCALE_ID, useValue: 'pt-BR' },
  ],
};
